<template>
  <v-card style="border-radius: 12px;" :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'">
    <v-card-title class="heading">
      <v-row align="center" class="ma-0">

        <span class="text--secondary text--darken-1">Marker</span>
        <v-spacer></v-spacer>
        <v-btn icon depressed @click="onSaveClick" :loading="isUpdating">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16669 10L8.33335 14.1667L16.6667 5.83337" stroke="#6CBE44" stroke-width="1.66667"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed @click="onCloseClick" :disabled="isUpdating">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 5L15 15" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-container fluid class="fill-height pa-0">
        <v-row class="ma-0">
          <v-col cols="12">
            <v-textarea label="Description" v-model="geometryData.strDescription" clearable outlined hide-details
              no-resize>
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

  </v-card>
</template>

<script>
import Wkt from "wicket"
import { FloatingCardsEventBus } from "../../../../helpers/mapview/events"
import { cloneDeep } from "lodash/lang"
import { FEATURE_CARD_STATE } from "../../../../helpers/geometries/constants"

const _MarkerLayer = Symbol.for("_MarkerLayer")
const _MarkerFeature = Symbol.for("_MarkerFeature")

export default {
  name: "MarkerEditCard",
  inject: { _MarkerFeature, _MarkerLayer },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isUpdating: false,
    bkpLayer: null,
    bkpGeometryData: {
      geometryData: null,
    },
    geometryData: {
      strDescription: null,
    },
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("close")
    },
    onCancelClick() {
      this.geometryData = cloneDeep(this.bkpGeometryData)
      this.Layer.setLatLng(this.bkpLayer.getLatLng())
      this.Layer.disableEdit()
      this.Layer.dragging.disable()
      this.$emit("update:mode", FEATURE_CARD_STATE.VIEW)
    },
    onSaveClick() {
      const geoJSON = this.Layer.toGeoJSON(),
        wkt = new Wkt.Wkt(),
        geoJsonWkt = wkt.read(JSON.stringify(geoJSON["geometry"])).write()
      const geometryData = {
        str_description: this.geometryData.strDescription,
        json_extra: this.Layer.getLatLng(),
        geo_feature: geoJsonWkt,
      }
      this.isUpdating = true
      this.Feature.update(this.Feature["id_processing_geometry"], geometryData)
        .then(() => {
          this.bkpLayer = cloneDeep(this.Layer)
          this.Layer.disableEdit()
          this.Layer.dragging.disable()
          this.$emit("update:mode", FEATURE_CARD_STATE.VIEW)
        })
        .finally(() => {
          this.isUpdating = false
        })
    }
  },
  computed: {
    Feature() {
      return this._MarkerFeature()
    },
    Layer() {
      return this._MarkerLayer()
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.geometryData.strDescription = this.Feature["str_description"]

      this.bkpGeometryData = cloneDeep(this.geometryData)
      this.bkpLayer = cloneDeep(this.Layer)

      this.Layer.enableEdit()
      this.Layer.dragging.enable()
    })
  }
}
</script>

<style scoped></style>
